"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageGrid = _interopRequireWildcard(require("./ImageGrid.styles"));

var _Layout = require("../Layout");
/* eslint-disable import/no-extraneous-dependencies */


var ImageGrid = function ImageGrid(_ref) {
  var list = _ref.list,
      itemsPerRow = _ref.itemsPerRow,
      size = _ref.size,
      title = _ref.title,
      id = _ref.id,
      backgroundColour = _ref.backgroundColour,
      titleColour = _ref.titleColour,
      rest = _objectWithoutProperties(_ref, ["list", "itemsPerRow", "size", "title", "id", "backgroundColour", "titleColour"]);

  var imgStyle = {
    objectFit: 'contain'
  };
  var desktopWidth = [2, 3, 4].includes(itemsPerRow) ? 12 / itemsPerRow : 4;
  var imgHeight = {
    small: '10rem',
    medium: '15rem',
    large: '20rem'
  };
  return /*#__PURE__*/_react.default.createElement(_ImageGrid.Container, Object.assign({
    backgroundColour: backgroundColour
  }, rest, {
    id: id
  }), title && /*#__PURE__*/_react.default.createElement(_ImageGrid.Title, {
    size: "medium",
    titleColour: titleColour
  }, title), /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    alignItems: "center",
    justifyContent: "center"
  }, list.map(function (img, key) {
    return /*#__PURE__*/_react.default.createElement(_Layout.Column // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(img.alt, "_").concat(key),
      p: "1rem",
      width: [6, 6, 6, desktopWidth]
    }, /*#__PURE__*/_react.default.createElement(_ImageGrid.default, Object.assign({
      height: imgHeight[size]
    }, img, {
      imgStyle: imgStyle
    })));
  })));
};

ImageGrid.propTypes = {
  id: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    alt: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  })).isRequired,
  itemsPerRow: _propTypes.default.oneOf([2, 3, 4]),
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  title: _propTypes.default.string,
  backgroundColour: _propTypes.default.oneOf(['none', 'white', 'offwhite', 'greymid', 'greydark', 'offblack', 'black', 'primary', 'secondary']),
  titleColour: _propTypes.default.oneOf([undefined, 'white', 'offwhite', 'greymid', 'greydark', 'offblack', 'black', 'primary', 'secondary'])
};
ImageGrid.defaultProps = {
  id: '',
  itemsPerRow: 4,
  size: 'large',
  title: '',
  backgroundColour: 'none',
  titleColour: undefined
};
var _default = ImageGrid;
exports.default = _default;